import * as React from "react";

import { IconProps } from "./types";

const HamburgerMenuIcon = ({
  className,
  width = 24,
  height = 25,
  strokeWidth = 2,
  style,
}: IconProps) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 -5 28 28"
    style={style}
  >
    <path
      d="M26.75 8.5H1.25M26.75 1H1.25M26.75 16.5H1.25"
      stroke="inherit"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HamburgerMenuIcon;
